import BaseComponent from '../../../../common/js/BaseComponent';

export default class ForceShowSubMenu extends BaseComponent {
    init(): any {
        if (document.querySelector('body:not(.editorial)')) {
            this.displaySubMenu();
        }
    }

    displaySubMenu() {
        const menu = document.querySelector('.desktop-nav .categories-item ul.dropdown-menu');
        const breadcrumb = document.querySelector('#breadcrumb-container');
        if (breadcrumb) {
            breadcrumb.classList.add('show');
        }
        if (menu) {
            menu.classList.add('show');
        }
        const firstLink = document.querySelector('#dropdownMenuLink');
        if (firstLink) {
            firstLink.classList.add('show');
        }
    }
}
